import * as React from 'react';
import { OptionsPanel } from './options-panel/options-panel';
import { PanelsProps, GroupingType } from './types';
import { sfNames, sfParameters } from './sf-names';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';

export const AccessToScreen = (props: PanelsProps) => {
  const { translation, readOnly, data, formComponent, formValues, endpoints, validation, clearValueInStore,
    roleSelected, roleBasedData, fetchingRoleBasedData, accessData, updateAccessData, clearValidation,
    levelsNotAllowed, options, loadOptions } = props;

  return <AdminPaperTopPanel title={translation.access_to_screen}>
    <OptionsPanel
      readOnly={readOnly}
      translation={translation}
      initialValue={data && data.accessToScreen}
      roleSelected={roleSelected}
      roleValue={roleBasedData && roleBasedData.accessToScreen}
      accessData={accessData && accessData.accessToScreen}
      updateAccessData={updateAccessData}
      fetchingRoleValue={fetchingRoleBasedData}
      formComponent={formComponent}
      formValues={formValues}
      formName={sfNames.accessToScreen}
      groupingName={sfParameters.application}
      groupingType={GroupingType.Multiple}
      valueName={sfParameters.domainNode}
      validation={validation}
      groupingOptionsEndpoint={endpoints.accesstoscreen.caseType}
      valuesOptionsEndpoint={endpoints.accesstoscreen.screen}
      groupingLabel={translation.case_type}
      valueLabel={translation.screen}
      addButtonText={translation.add_case_type_button_text}
      clearValueInStore={clearValueInStore}
      clearValidation={clearValidation}
      useLabelOption={readOnly}
      singleStepAccess={true}
      levelsNotAllowed={levelsNotAllowed && levelsNotAllowed.accessToScreen}
      options={options}
      loadOptions={loadOptions}
      displaySelectAll={true}
    />
  </AdminPaperTopPanel>;
};
